import type { AxiosResponse } from 'axios'
import { call, put, select, takeLatest } from 'redux-saga/effects'

import { getActiveCompanyId, getErrorMessage } from '@helpers'

import actions from './actions'
import * as api from './api'

function* fetchCompanyTaxationDetailsSaga() {
  try {
    const companyId: Company['id'] = yield select(getActiveCompanyId)
    const response: AxiosResponse = yield call(api.fetchCompanyTaxationDetails, companyId)
    yield put(actions.fetchCompanyTaxationDetails.success(response.data))
  } catch (error) {
    yield put(actions.fetchCompanyTaxationDetails.failure(getErrorMessage(error)))
  }
}

// watcher Saga
export default function* taxationDetailsSaga() {
  yield takeLatest(actions.fetchCompanyTaxationDetails.REQUEST, fetchCompanyTaxationDetailsSaga)
}
